<template>
  <div class="mc-trackvideo-card--video" :class="{ 'mc-trackvideo-card--video-fill': isFill }">
    <video-stream-player
      v-if="isVideoDemo"
      :ref="`videoPlayerDemo${source.id}`"
      class="vjs-custom-skin"
      :src="source.src"
      :playerId="`videoPlayerDemo${source.id}`"
      crossorigin="anonymous"
      @ready="onInPlayerDemoReady()"
      @ended="onVideoDemoEnded"
    />
    <video-stream-player
      v-else-if="isFlespiHowen && source.src"
      :ref="`videoPlayer${source.id}`"
      class="vjs-custom-skin"
      :src="source.src"
      :playerId="`${source.id}`"
      @ready="onPlayerFlespiReady($event)"
      @error="onPlayerFlespiError($event)"
      @loadeddata="onPlayerFlespiLoadedData($event)"
    />
    <video-stream-vss
      v-else-if="isVssHowen"
      :ref="`videoPlayer${source.id}`"
      :channel="Number(source.channel)"
      :imei="source.imei"
      :playlist-id="playlistId"
      :type="'live'"
      :default-open-audio="!muted"
      @ready="onPlayerVssReady($event)"
      @stop="onPlayerVssStop($event)"
    />
    <video-stream-player
      v-else-if="isHlsTesting"
      :ref="`videoPlayer${source.id}`"
      class="vjs-custom-skin"
      type="stream"
      :src="source.src"
      :playerId="`${source.id}`"
      :isRecording="isRecording"
      @ready="onReady"
      @error="onError"
      @destroyed="onDestroyed"
      @loadeddata="onLoadDataHls"
    />
    <video-stream-flv
      v-else
      :ref="`videoPlayer${source.id}`"
      class="vjs-custom-skin"
      type="stream"
      :src="source.src"
      :playerId="`${source.id}`"
      :isRecording="isRecording"
      @ready="onReady"
      @loadeddata="onLoadDataFlv"
      @error="onError"
      @destroyed="onDestroyed"
      @pendingTimeout="onPendingTimeout"
    />

    <div v-if="showMic" class="mc-trackvideo-card--video-mic">
      <div v-b-tooltip.hover.left :title="$t('trackVideo.callsInProgress')">
        <MicAnimation />
      </div>
    </div>
    <div class="mc-trackvideo--video-close_wrapper">
      <span class="mc-trackvideo--video-close" @click="closeVideo()">
        <i class="mc-fa icon-outline_close" />
      </span>
    </div>
    <div class="mc-trackvideo-card--video-action justify-content-between">
      <div class="d-flex gap-2">
        <!--  eslint-disable-next-line i18next/no-literal-string -->
        <!-- uncomment if needed -->
        <!-- <span class="mc-trackvideo-card--video-action-bandwitch">{{ bandwidth }} KB/s</span> -->

        <span>
          <i
            v-if="!muted"
            class="mc-fa icon-outline_volume-up"
            :class="{ 'mc-trackvideo-mute--disabled': isRecording }"
            @click="muteVideo"
          ></i>
          <i v-else class="mc-fa icon-outline_volume-off" @click="muteVideo"></i>
        </span>
        <div style="width: 18px; height: 18px"></div>
      </div>
      <div class="mc-trackvideo-card--video-action-center" :class="{ 'no-record': isVssHowen }">
        <span @click="captureImage">
          <i class="mc-fa icon-fill_camera"></i><span>{{ $t('trackVideo.snapshots') }} </span>
        </span>

        <div v-if="isProcessingVideo" class="mc-trackvideo-action--processing-video">
          <b-spinner small />
          <span class="mc-tooltip-processing-video">
            {{ $t('trackVideo.processingVideo') }} ...
          </span>
        </div>
        <span v-else>
          <i v-show="!isRecording" class="mc-fa icon-fill_videorecord" @click="startRecording"> </i>
          <span v-show="!isRecording">{{ $t('trackVideo.record') }}</span>
          <i
            v-show="isRecording"
            class="mc-fa icon-fill_stop-videorecord"
            @click="stopRecording"
          ></i>
          <span v-show="isRecording">{{ $t('trackVideo.stopRecording') }}</span>
        </span>

        <template
          v-if="
            (source.deviceType === 'bsj' || source.deviceType === 'vss-howen') &&
            hasAccessAll([
              'b3f-two-way-communication:read',
              'b3f-two-way-communication-all-module:read',
            ])
          "
        >
          <span>
            <i v-if="isVoipTwoWayActive" class="mc-fa icon-fill_phone-off" @click="endCall"> </i>
            <i
              v-else
              class="mc-fa icon-fill_phone"
              :class="{
                disabled:
                  (vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                    !isVoipTwoWayActive) ||
                  isVoipBroadcastActive,
              }"
              @click="
                ;(vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                  !isVoipTwoWayActive) ||
                isVoipBroadcastActive
                  ? undefined
                  : startCall()
              "
            >
            </i>
            <span v-if="isVoipTwoWayActive">
              {{ $t('trackVideo.endCall') }}
            </span>
            <span
              v-else-if="
                !(
                  (vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                    !isVoipTwoWayActive) ||
                  isVoipBroadcastActive
                )
              "
            >
              {{ $t('trackVideo.callDriver') }}
            </span>
          </span>
        </template>
      </div>
      <div class="mc-trackvideo-card--video-action-right">
        <span @click="toggleFillFit()">
          <i class="mc-fa icon-fill_fit-screen"></i>
          <i class="mc-fa icon-fill_fill-screen"></i>
        </span>
        <span @click="toggleFullscreen()">
          <i class="mc-fa icon-fill_fullscreen"></i>
          <i class="mc-fa icon-fill_exit-fullscreen"></i>
        </span>
      </div>
    </div>
    <div class="mc-trackvideo-card--video-action-responsive justify-content-between">
      <span class="mc-trackvideo-card--video-action-wrapper">
        <i
          v-if="!muted"
          class="mc-fa icon-outline_volume-up"
          :class="{ 'mc-trackvideo-mute--disabled': isRecording }"
          @click="muteVideo"
        ></i>
        <i v-else class="mc-fa icon-outline_volume-off" @click="muteVideo"></i>
      </span>
      <div tabindex="0" @blur="showMoreOptions = false">
        <span class="mc-trackvideo-card--video-action-wrapper" @click="toggleOptions">
          <i class="mc-fa icon-outline_more-vertical" />
        </span>

        <ul v-if="showMoreOptions" class="dropdown-menu mc-trackvideo-card--video-action-more">
          <template
            v-if="
              (source.deviceType === 'bsj' || source.deviceType === 'vss-howen') &&
              hasAccessAll([
                'b3f-two-way-communication:read',
                'b3f-two-way-communication-all-module:read',
              ])
            "
          >
            <li v-if="isVoipTwoWayActive" @click="endCall">
              <i class="mc-fa icon-fill_phone-off" />
              {{ $t('trackVideo.endCall') }}
            </li>
            <li
              v-else
              :class="{
                disabled:
                  (vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                    !isVoipTwoWayActive) ||
                  isVoipBroadcastActive,
              }"
              @click="
                ;(vehicleIdsCallActive.length >= $store.state.voip.maxCall &&
                  !isVoipTwoWayActive) ||
                isVoipBroadcastActive
                  ? undefined
                  : startCall()
              "
            >
              <i class="mc-fa icon-fill_phone" />
              {{ $t('trackVideo.callDriver') }}
            </li>
          </template>

          <li @click="captureImage">
            <i class="mc-fa icon-fill_camera" />{{ $t('trackVideo.snapshots') }}
          </li>
          <li v-if="recordIdActive === source.id" @click="stopRecording">
            <i class="mc-fa icon-fill_stop-videorecord" />
            {{ $t('trackVideo.stopRecording') }}
          </li>
          <li
            v-else
            :class="{ disabled: !!recordIdActive && recordIdActive !== source.id }"
            @click="!!recordIdActive && recordIdActive !== source.id ? undefined : startRecording()"
          >
            <i class="mc-fa icon-fill_videorecord" />
            {{ $t('trackVideo.record') }}
          </li>

          <li @click="toggleFillFit">
            <i v-show="isFill" class="mc-fa icon-fill_fit-screen"></i>
            <i v-show="!isFill" class="mc-fa icon-fill_fill-screen"></i>
            {{ isFill ? 'Fit-Screen' : 'Fill-Screen' }}
          </li>
          <li @click="toggleFullscreen">
            <i v-show="!source.fullscreen" class="mc-fa icon-fill_fullscreen"></i>
            <i v-show="source.fullscreen" class="mc-fa icon-fill_exit-fullscreen"></i>
            {{ !source.fullscreen ? 'Fullscreen' : 'Exit Fullscreen' }}
          </li>
        </ul>
      </div>
    </div>

    <span v-if="isRecording" class="mc-trackvideo-card--video-action-record" @click="stopRecording">
      <u>
        <span>{{ $t('trackVideo.stopRecording') }}</span>
      </u>
      | {{ $t('trackVideo.recording') }} : {{ `${timerString}` }}
    </span>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import VideoStreamFlv from '@/components/Video/VideoStreamFlv.vue'
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import VideoStreamPlayer from '@/components/Video/VideoStreamPlayer.vue'
import VideoStreamVss from '@/components/Video/VideoStreamVss.vue'
import MicAnimation from '../MicAnimation.vue'
import VideoRecorder from '../../lib/VideoRecorder'
import CanvasFrameRecorder from '../../lib/CanvasRecorder'
import { MixPanel } from '@/mixin/mixpanel'

moment.locale('id')

export default {
  name: 'VideoState',
  components: {
    VideoStreamFlv,
    VideoStreamPlayer,
    MicAnimation,
    VideoStreamVss,
  },

  mixins: [Helper, MixPanel],

  props: {
    source: {
      required: true,
      type: Object,
    },
    playlistId: {
      required: true,
      type: String,
    },
    isMdvrSleep: {
      required: true,
      type: Boolean,
    },
  },

  data() {
    return {
      muted: true,
      isFill: true,

      capturedFrames: [],
      isRecording: false,
      isProcessingVideo: false,
      recordInterval: null,
      bandwidth: 0,
      supportedType: '',

      hour: 0,
      minute: 0,
      second: 0,
      count: 0,
      timerString: '00:00:00',
      watchInterval: null,

      errorState: 0,
      readyState: false,
      timeoutVideo: null,
      maxAttemptsError: 10,

      fpsRecording: 8,
      recorder: null,
      canvasRecorder: null,
      audioDestination: null,

      showMoreOptions: false,

      // for case MDVR
      isVideoSleep: false,
      isCoundownSleepEnd: false,

      isLoadDataFlv: false,
    }
  },

  computed: {
    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    ...mapGetters('video', ['flespiHowenVehicleIds', 'fleetsList']),
    ...mapState('video', ['workerTrackvision', 'recordIdActive']),
    ...mapGetters('voip', ['vehicleIdsCallActive', 'vehicleIdsBroadcastActive']),

    isVideoDemo() {
      const dataDemoTrackvision = JSON.parse(
        this.getFeatureFlagData('vsms2_trackvision2_stream_demo_id').value
      )
      const isVideoDemo = Object.keys(dataDemoTrackvision).includes(
        this.source.vehicleId.toString()
      )
      return isVideoDemo
    },
    isFlespiHowen() {
      return this.flespiHowenVehicleIds.includes(parseInt(this.source.vehicleId))
    },
    isVssHowen() {
      return this.source.deviceType === 'vss-howen'
    },
    showMic() {
      const callState = this.$store.state.voip.voipState[this.source.vehicleId]
      if (!callState || callState.state !== 'onGoing') return false
      return true
    },
    isHlsTesting() {
      return JSON.parse(this.getFeatureFlagData('is_hls_testing').value)
    },
    isVoipTwoWayActive() {
      return this.vehicleIdsCallActive.includes(Number(this.source.vehicleId))
    },
    isVoipBroadcastActive() {
      return this.vehicleIdsBroadcastActive.includes(Number(this.source.vehicleId))
    },
  },

  watch: {
    timerString(timerString) {
      if (timerString === '00:03:00') {
        this.isRecording = false
        this.stopRecording()
      }
    },
    isVoipTwoWayActive(isVoipTwoWayActive) {
      if (isVoipTwoWayActive && !this.muted) {
        this.muteVideo()
      }
    },
  },

  async mounted() {
    const ref = this.isVideoDemo
      ? this.$refs[`videoPlayerDemo${this.source.id}`]
      : this.$refs[`videoPlayer${this.source.id}`]
    const playerRef = ref.player
    await this.$nextTick()
    if (this.isVssHowen) {
      const canvasVideoElement = ref.$el.querySelector('canvas')
      this.canvasRecorder = new CanvasFrameRecorder(canvasVideoElement)
    } else {
      this.recorder = new VideoRecorder(playerRef)
    }
  },

  beforeDestroy() {
    clearTimeout(this.timeoutVideo)
    if (this.isRecording) {
      this.stopRecording()
      clearInterval(this.recordInterval)
    }
    // Cleanup audio context when component is destroyed
    if (this.recorder) {
      this.recorder.cleanup()
    }
  },

  methods: {
    onVideoDemoEnded() {
      var refsName = `videoPlayerDemo${this.source.id}`
      this.$refs[refsName].player.play()
    },

    onDestroyed(videoId, flv) {
      if (this.isVideoDemo) return
      this.isVideoSleep = false
      this.isCoundownSleepEnd = false
      flv.destroy()
    },
    onInPlayerDemoReady() {
      var refsName = `videoPlayerDemo${this.source.id}`
      this.$emit('ready')
      this.$refs[refsName].player.play()
      this.$refs[refsName].player.muted = true
    },
    toggleFullscreen() {
      document.body.classList.toggle('mc-trackvideo-fullscreen--detail')
      this.$emit('fullscreen')
    },

    async onReady() {
      if (this.isVideoDemo || this.readyState) return

      this.readyState = true

      if (this.isVideoSleep) {
        this.isVideoSleep = false
        this.isCoundownSleepEnd = false
      }

      const isPlayFirstTime = this.source.videoStatus === 'connecting'

      if (isPlayFirstTime) {
        this.$emit('startPlay')
      }

      clearTimeout(this.timeoutVideo)

      let timeoutVideo = 5 * 60 * 1000,
        mapTimeout = {}
      const featureHubTimeoutVideo = this.getFeatureFlagData(
        'trackvision_map_company_streaming_timeout'
      )?.value

      if (typeof featureHubTimeoutVideo === 'string') {
        mapTimeout = JSON.parse(featureHubTimeoutVideo)
      }
      if (mapTimeout[this.$store.state.identity.whoami?.companyId]) {
        timeoutVideo = mapTimeout[this.$store.state.identity.whoami?.companyId]
      }

      this.timeoutVideo = setTimeout(async () => {
        this.$emit('setPlaylistTimeout')
        if (this.isRecording) {
          this.stopRecording()
        }
      }, timeoutVideo)

      this.errorState = 0

      this.$emit('ready')
    },

    onLoadDataFlv(data, bandwidth) {
      if (!this.isLoadDataFlv) {
        // this.onReady()
        this.isLoadDataFlv = true
        return
      }
      if (this.isVideoDemo) return
      this.bandwidth = bandwidth
      this.$emit('load')
    },

    /**
     *
     * @param _
     * @param data
     * @param bandwith in bits per second
     */
    onLoadDataHls(_, data, bandwith) {
      this.isVideoSleep = false
      this.isCoundownSleepEnd = false
      this.bandwidth = (bandwith / 1000).toFixed(2) // convert to kb per second
    },

    // handler event when player freeze
    onPendingTimeout() {
      this.isLoadDataFlv = false
      if (this.isVideoDemo) return
      if (this.isVideoSleep) return

      clearTimeout(this.timeoutVideo)
      this.errorState = 0
      this.$emit('error')
      this.$forceUpdate()
    },

    reinitPlayerWhenSleep() {
      setTimeout(() => {
        this.$refs[`videoPlayer${this.source.id}`].initialize()
      }, 1000)
    },

    countdownSleepEnd() {
      this.isVideoSleep = false
      this.isCoundownSleepEnd = true
      this.errorState = 0
    },

    onError() {
      this.isLoadDataFlv = false
      if (this.isVideoDemo) return
      if (this.source.videoStatus === 'timeout') return
      if (this.isCoundownSleepEnd) {
        this.isCoundownSleepEnd = false
        return
      }
      if (this.isVideoSleep) {
        this.reinitPlayerWhenSleep()
        return
      }

      this.isCoundownSleepEnd = false

      const maxAttemptsFeatureHub = Number(
        JSON.parse(this.getFeatureFlagData('trackvision_timeout_video').value)
      )
      let maxAttempts = this.source.deviceType === 'flespi-howen' ? 30 : 10
      if (maxAttemptsFeatureHub) {
        maxAttempts = maxAttemptsFeatureHub
      }

      // check if prev state is ready (video is play)
      if (this.readyState) {
        this.$emit('connecting')
        this.errorState = 0
        this.readyState = false
        if (this.isRecording) {
          this.stopRecording()
        }
      }

      // check if max attempts error reached
      if (this.errorState >= maxAttempts) {
        clearTimeout(this.timeoutVideo)
        this.errorState = 0
        if (this.isMdvrSleep) {
          this.$emit('sleep')
          this.isVideoSleep = true
          this.isCoundownSleepEnd = false
          this.reinitPlayerWhenSleep()
        } else {
          this.$emit('error')
        }
        return
      }

      setTimeout(() => {
        this.$refs[`videoPlayer${this.source.id}`].initialize()
        this.errorState++
      }, 1000)
    },

    pauseVideo() {
      this.$emit('pause')
    },

    async muteVideo() {
      if (this.isRecording) return
      this.muted = !this.muted
      await this.$nextTick()

      // If recorder has AudioContext active, use gain node for mute control
      if (this.recorder && this.recorder.setMuted(this.muted)) {
        // Successfully muted via AudioContext gain node
        return
      }

      // Otherwise use normal mute control
      if (this.isVideoDemo) {
        var refsName = `videoPlayerDemo${this.source.id}`
        this.$refs[refsName].player.muted = !this.$refs[refsName].player.muted
      } else if (this.isVssHowen) {
        this.$refs[`videoPlayer${this.source.id}`].setOpenAudio(!this.muted)
      } else {
        this.$emit('mute')
      }
    },

    captureImage() {
      const ref = this.isVideoDemo
        ? this.$refs[`videoPlayerDemo${this.source.id}`]
        : this.$refs[`videoPlayer${this.source.id}`]

      const canvas = document.createElement('canvas')
      let dataURL

      if (this.isVssHowen) {
        const canvasVideoElement = ref.$el.querySelector('canvas')
        dataURL = canvasVideoElement.toDataURL('image/png')
      } else {
        canvas.width = ref.player.videoWidth
        canvas.height = ref.player.videoHeight

        canvas.setAttribute('crossOrigin', 'Anonymous')
        const ctx = canvas.getContext('2d')
        ctx.drawImage(ref.player, 0, 0, canvas.width, canvas.height)
        dataURL = canvas.toDataURL('image/png') // Convert canvas to data URL
      }

      const a = document.createElement('a')
      a.href = dataURL
      const dateTimes = moment(new Date()).format('YYYYMMDD-HHmmss')
      a.download = `${this.source.licensePlate}-kamera${this.source.camera}-live-${dateTimes}.png` // Set the filename for the downloaded image
      a.click()
    },

    determineSupportedType() {
      const supportedTypes = [
        'video/webm;codecs=vp8',
        'video/webm;codecs=vp9',
        'video/webm;codecs=vp8.0',
        'video/webm;codecs=vp9.0',
        'video/webm',
        'video/mp4',
        'video/ogg',
      ]

      for (const type of supportedTypes) {
        if (MediaRecorder.isTypeSupported(type)) {
          this.supportedType = type
          break
        }
      }

      if (!this.supportedType) {
        // eslint-disable-next-line no-console
        console.error('No supported MIME type found for MediaRecorder')
      }
    },

    async startRecording() {
      this.determineSupportedType()
      this.startWatch()

      if (this.muted) {
        await this.muteVideo()
        await this.$nextTick()
      }

      this.isRecording = true
      this.$store.commit('video/setRecordIdActive', this.source.id)
      if (this.isVssHowen) {
        const ref = this.$refs[`videoPlayer${this.source.id}`]
        const pcmPlayer = ref.playerVss.pcmPlayer
        if (pcmPlayer && pcmPlayer.audioCtx) {
          this.audioDestination = pcmPlayer.audioCtx.createMediaStreamDestination()
          pcmPlayer.gainNode.connect(this.audioDestination)
          await this.canvasRecorder.startRecording(this.audioDestination.stream)
        } else {
          await this.canvasRecorder.startRecording()
        }
      } else {
        await this.recorder.startRecording()
      }
      await this.$nextTick()

      // Force unmute after recording starts (Firefox may auto-mute)
      if (!this.muted && !this.isVssHowen) {
        await this.$nextTick()
        const ref = this.$refs[`videoPlayer${this.source.id}`]
        if (ref && ref.player) {
          ref.player.muted = false
        }
      }
    },
    startWatch() {
      this.watchInterval = setInterval(() => {
        this.second++

        if (this.second == 60) {
          this.minute++
          this.second = 0
        }

        if (this.minute == 60) {
          this.hour++
          this.minute = 0
          this.second = 0
        }

        let hrString = this.hour
        let minString = this.minute
        let secString = this.second

        if (this.hour < 10) {
          hrString = '0' + hrString
        }

        if (this.minute < 10) {
          minString = '0' + minString
        }

        if (this.second < 10) {
          secString = '0' + secString
        }

        this.timerString = `${hrString}:${minString}:${secString}`
      }, 1000)
    },
    stopWatch() {
      clearInterval(this.watchInterval)
      this.hour = 0
      this.minute = 0
      this.second = 0
      this.count = 0
      this.timerString = '00:00:00'
    },
    async stopRecording() {
      this.stopWatch()
      this.isRecording = false
      this.isProcessingVideo = true

      clearInterval(this.recordInterval)
      await this.$nextTick()
      let recordedBlob
      if (this.isVssHowen) {
        recordedBlob = await this.canvasRecorder.stopRecording()
      } else {
        recordedBlob = await this.recorder.stopRecording()
      }

      // Create a link element to trigger the download
      const dateTimes = moment(new Date()).format('YYYYMMDD-HHmmss')

      const filename = `${this.source.licensePlate}-kamera${this.source.camera}-live-${dateTimes}.webm` // Set the filename for the downloaded video

      if (this.isVssHowen) {
        this.canvasRecorder.download(filename)
        this.audioDestination = null
      } else {
        this.recorder.download(filename)
      }
      this.isProcessingVideo = false
      this.$store.commit('video/resetRecordIdActive')
    },

    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1])
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i)
      }
      return new Blob([arrayBuffer], { type: mimeString })
    },
    toggleFillFit() {
      this.isFill = !this.isFill
    },
    closeVideo() {
      this.track('Unselect Stream: Stop Video Streaming')
      const id = this.source.id
      this.$store.commit('video/removePlaylist', id)
      this.$store.commit('video/setLastClosedPlaylist', id)
      if (this.source.fullscreen) {
        this.toggleFullscreen()
      }
    },
    onPlayerFlespiReady(e) {
      var refsName = `videoPlayer${this.source.id}`
      this.$refs[refsName].player.play()
      this.$refs[refsName].player.muted = true
    },
    onPlayerFlespiError(e) {
      this.$emit('connecting')
    },
    onPlayerFlespiLoadedData(e) {
      this.$emit('ready')

      var refsName = `videoPlayer${this.source.id}`
      this.$refs[refsName].player.play()
      this.$refs[refsName].player.muted = true
    },
    onPlayerVssReady() {
      clearTimeout(this.timeoutVideo)
      this.$emit('ready')
      let timeoutVideo = 5 * 60 * 1000,
        mapTimeout = {}
      const featureHubTimeoutVideo = this.getFeatureFlagData(
        'trackvision_map_company_streaming_timeout'
      )?.value

      if (typeof featureHubTimeoutVideo === 'string') {
        mapTimeout = JSON.parse(featureHubTimeoutVideo)
      }
      if (mapTimeout[this.$store.state.identity.whoami?.companyId]) {
        timeoutVideo = mapTimeout[this.$store.state.identity.whoami?.companyId]
      }

      this.timeoutVideo = setTimeout(async () => {
        this.$emit('setPlaylistTimeout')
      }, timeoutVideo)
    },
    onPlayerVssStop() {
      clearTimeout(this.timeoutVideo)
      this.$emit('error')
    },
    startCall() {
      this.track('Media Player Streaming - VoIP Admin make a call', {
        entryPoint: 'Media Player Streaming',
      })
      this.$store.dispatch('voip/startNewCall', {
        dataNewCall: {
          vehicleId: Number(this.source.vehicleId),
          licensePlate: this.source.licensePlate,
          driver: this.source.driver ?? null,
          imei: this.source.imei,
          deviceType: this.source.deviceType,
          entryPoint: 'mediaPlayerStreaming',
        },
      })
    },
    endCall() {
      this.track('Media Player Streaming - VoIP End Call', {
        entryPoint: 'Media Player Streaming',
      })
      this.$store.dispatch('voip/endCall', { vehicleId: Number(this.source.vehicleId) })
    },
    toggleOptions() {
      this.showMoreOptions = !this.showMoreOptions
    },
  },
}
</script>
